export default __webpack_public_path__ + "static/B0154-0adeb4ec5c0b2b3b2e7753721c4cdaef.png";